var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.724609,
    width: 53.55,
    height: 53.55,
    rx: 16.5,
    fill: "url(#paint0_linear_443_5634)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_443_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 40C20.0486 40 13.2913 36.1421 8.30515 29.8758C7.89828 29.3624 7.89828 28.6452 8.30515 28.1318C13.2913 21.8579 20.0486 18 27.5 18C34.9514 18 41.7087 21.8579 46.6948 28.1242C47.1017 28.6376 47.1017 29.3548 46.6948 29.8682C41.7087 36.1421 34.9514 40 27.5 40ZM28.0345 21.2539C23.0882 20.9595 19.0035 24.8174 19.3147 29.5058C19.57 33.3713 22.8808 36.5045 26.9655 36.7461C31.9118 37.0405 35.9965 33.1826 35.6853 28.4942C35.4221 24.6362 32.1112 21.5031 28.0345 21.2539ZM27.7872 24.8325C25.1226 24.674 22.9207 26.7502 23.0962 29.2718C23.2318 31.3555 25.0189 33.0391 27.2208 33.175C29.8854 33.3336 32.0873 31.2574 31.9118 28.7358C31.7682 26.6445 29.9811 24.9609 27.7872 24.8325Z",
    fill: "#2F3136"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_443_5634",
    x: 5,
    y: 17,
    width: 45,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_443_5634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_443_5634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_5634",
    x1: 26.775,
    y1: 0.724609,
    x2: 26.775,
    y2: 54.2746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3C679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8BE8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo_2.6b9e5e4e8bf48a07cba8cf36993a3742.svg";
export { ForwardRef as ReactComponent };